import { ReactNode } from 'react';
import useGuest from 'hooks/useGuest';

import { FeatureFlagProvider } from './FeatureFlagProvider';

/**
 * The app root's FeatureFlagProvider, fed the token-backed guest session.
 * Deliberately not exported from `featureFlags`: it imports the auth module
 * (and through it the store), which flagged components' tests must not load.
 */
export const SessionFeatureFlagProvider = ({ children }: { children: ReactNode }) => (
  <FeatureFlagProvider guestSession={useGuest()}>{children}</FeatureFlagProvider>
);
